var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{ref:"bg",staticClass:"bg"}),_c('header',{staticClass:"header"},[_vm._m(0),_c('div',{staticClass:"w-2/3"},[_c('LoginWidget')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-1/3 flex items-center"},[_c('span',{staticClass:"mobile"},[_vm._v("EWH.")]),_c('span',{staticClass:"desktop"},[_vm._v("EWH. Das Archiv.")])])
}]

export { render, staticRenderFns }